import type { updateCustomPropertiesBodyZod } from "@nlc/shared-types";
import type * as z from "zod";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { notificationsKeys } from "@/hooks/queryKeys";
import { useUser } from "@/hooks/useUser";
import apiClient from "@/lib/api/client";

export type UpdateCustomPropertiesFormData = z.infer<
  typeof updateCustomPropertiesBodyZod
>;

export function useUpdateCustomProperties() {
  const { data: user } = useUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: UpdateCustomPropertiesFormData) =>
      apiClient
        .url(`/notifications/supr-send/custom-properties`)
        .patch(data)
        .json(),
    mutationKey: notificationsKeys.updateCustomProperties(),
    onError: (err) => {
      console.error("error", err);
    },
    onSuccess: async () => {
      const email = user?.user?.email;

      if (email) {
        await queryClient.invalidateQueries({
          queryKey: notificationsKeys.user(email),
        });
      }
    },
  });
}
